// @ts-nocheck

import { createStructuredSelector } from 'reselect';

import {
  selectUserJwtToken,
  selectUserMessages,
  selectUserMustValidateCGU,
  selectUserMustValidateEvents,
} from '../../selectors/user/userPrimary.selector';

const selectUserNotificationProps = createStructuredSelector({
  messages: selectUserMessages,
  mustValidateEvents: selectUserMustValidateEvents,
  mustValidateCGU: selectUserMustValidateCGU,
  jwt: selectUserJwtToken,
});

export default selectUserNotificationProps;
